/**
 * WebGL2-safe particle shaders.
 * Do not redeclare `precision` — Three.js already injects it.
 * Call toneMapping/linearToOutputTexel so output matches PointsMaterial.
 */
export const particleVertex = /* glsl */ `
attribute float aSize;
attribute vec3 aColor;
uniform float uPixelRatio;
uniform float uSize;
uniform float uEnergy;
varying vec3 vColor;
varying float vAlpha;

void main() {
  vColor = aColor;
  float energy = clamp(uEnergy, 0.0, 1.0);
  vAlpha = mix(0.72, 0.95, energy);
  vec4 mvPosition = modelViewMatrix * vec4(position, 1.0);
  float dist = max(1.0, -mvPosition.z);
  float pixels = aSize * uSize * (uPixelRatio * 70.0 / dist);
  gl_PointSize = clamp(pixels, 3.0, 8.0);
  gl_Position = projectionMatrix * mvPosition;
}
`;

export const particleFragment = /* glsl */ `
varying vec3 vColor;
varying float vAlpha;

void main() {
  vec2 p = gl_PointCoord * 2.0 - 1.0;
  float d = length(p);
  if (d > 1.0) discard;
  float falloff = 1.0 - d;
  float alpha = clamp(pow(falloff, 1.35) * vAlpha, 0.0, 1.0);
  vec3 color = vColor;
  gl_FragColor = vec4(color, alpha);
  #ifdef TONE_MAPPING
    gl_FragColor.rgb = toneMapping(gl_FragColor.rgb);
  #endif
  gl_FragColor = linearToOutputTexel(gl_FragColor);
}
`;
